export const icons = {
  terminal: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="4 17 10 11 4 5"></polyline>
      <line x1="12" y1="19" x2="20" y2="19"></line>
    </svg>
  `,
  zap: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
    </svg>
  `,
  github: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="currentColor" viewBox="0 0 24 24">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.53 1.032 1.53 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"></path>
    </svg>
  `,
  mastodon: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="currentColor" viewBox="0 0 24 24">
      <path d="M21.327 8.566c0-4.339-2.843-5.61-2.843-5.61-1.433-.658-3.894-.935-6.451-.956h-.063c-2.557.021-5.016.298-6.45.956 0 0-2.843 1.272-2.843 5.61 0 .993-.019 2.181.012 3.441.103 4.243.778 8.425 4.701 9.463 1.809.479 3.362.579 4.612.51 2.268-.126 3.541-.809 3.541-.809l-.075-1.646s-1.621.511-3.441.449c-1.804-.062-3.707-.194-3.999-2.409a4.523 4.523 0 0 1-.04-.621s1.77.433 4.014.536c1.372.063 2.658-.08 3.96-.213 2.892-.294 5.418-1.785 5.715-5.152.05-.568.087-1.144.103-1.716.033-1.393.004-1.793.004-1.793zm-3.498 7.009h-2.128v-5.267c0-1.107-.468-1.67-1.405-1.67-1.037 0-1.556.671-1.556 2.002v2.873h-1.48v-2.873c0-1.331-.519-2.002-1.556-2.002-.937 0-1.405.563-1.405 1.67v5.267H6.171V10.15c0-1.106.282-1.989.846-2.65.58-.679 1.341-1.032 2.285-1.032 1.094 0 1.928.42 2.493 1.258l.606.985.606-.985c.565-.838 1.399-1.258 2.493-1.258.944 0 1.705.353 2.285 1.032.564.661.846 1.544.846 2.65v5.425z"/>
    </svg>
  `,
  download: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
    </svg>
  `,
  packageIcon: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
    </svg>
  `,
  bookOpen: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
    </svg>
  `,
  messageSquare: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
    </svg>
  `,
  copy: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"></path>
    </svg>
  `,
  check: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="20 6 9 17 4 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
    </svg>
  `,
  layers: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polygon points="12 2 2 7 12 12 22 7 12 2" stroke-width="2"></polygon>
      <polyline points="2 17 12 22 22 17" stroke-width="2"></polyline>
      <polyline points="2 12 12 17 22 12" stroke-width="2"></polyline>
    </svg>
  `,
  keyboard: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="2" y="4" width="20" height="16" rx="2" stroke-width="2"></rect>
      <line x1="6" y1="8" x2="6" y2="8" stroke-width="2" stroke-linecap="round"></line>
      <line x1="10" y1="8" x2="10" y2="8" stroke-width="2" stroke-linecap="round"></line>
      <line x1="14" y1="8" x2="14" y2="8" stroke-width="2" stroke-linecap="round"></line>
      <line x1="18" y1="8" x2="18" y2="8" stroke-width="2" stroke-linecap="round"></line>
      <line x1="6" y1="12" x2="6" y2="12" stroke-width="2" stroke-linecap="round"></line>
      <line x1="10" y1="12" x2="10" y2="12" stroke-width="2" stroke-linecap="round"></line>
      <line x1="14" y1="12" x2="14" y2="12" stroke-width="2" stroke-linecap="round"></line>
      <line x1="18" y1="12" x2="18" y2="12" stroke-width="2" stroke-linecap="round"></line>
      <line x1="7" y1="16" x2="17" y2="16" stroke-width="2" stroke-linecap="round"></line>
    </svg>
  `,
  image: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke-width="2"></rect>
      <circle cx="8.5" cy="8.5" r="1.5" stroke-width="2"></circle>
      <polyline points="21 15 16 10 5 21" stroke-width="2"></polyline>
    </svg>
  `,
  search: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="11" cy="11" r="8" stroke-width="2"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65" stroke-width="2"></line>
    </svg>
  `,
  bug: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect width="8" height="14" x="8" y="6" rx="4" stroke-width="2"></rect>
      <path d="m19 7-3 2" stroke-width="2"></path>
      <path d="m5 7 3 2" stroke-width="2"></path>
      <path d="m19 19-3-2" stroke-width="2"></path>
      <path d="m5 19 3-2" stroke-width="2"></path>
      <path d="M20 13h-4" stroke-width="2"></path>
      <path d="M4 13h4" stroke-width="2"></path>
      <path d="m10 4 1 2" stroke-width="2"></path>
      <path d="m14 4-1 2" stroke-width="2"></path>
    </svg>
  `,
  lightbulb: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
    </svg>
  `,
  shield: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
    </svg>
  `,
  badgeCheck: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
    </svg>
  `,
  flask: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"></path>
    </svg>
  `,
  externalLink: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
    </svg>
  `,
  close: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <line x1="18" y1="6" x2="6" y2="18" stroke-width="2" stroke-linecap="round"></line>
      <line x1="6" y1="6" x2="18" y2="18" stroke-width="2" stroke-linecap="round"></line>
    </svg>
  `,
  menu: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <line x1="3" y1="12" x2="21" y2="12" stroke-width="2" stroke-linecap="round"></line>
      <line x1="3" y1="6" x2="21" y2="6" stroke-width="2" stroke-linecap="round"></line>
      <line x1="3" y1="18" x2="21" y2="18" stroke-width="2" stroke-linecap="round"></line>
    </svg>
  `,
  chevronDown: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="6 9 12 15 18 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
    </svg>
  `,
  chevronRight: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="9 18 15 12 9 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
    </svg>
  `,
  arrowRight: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <line x1="5" y1="12" x2="19" y2="12" stroke-width="2" stroke-linecap="round"></line>
      <polyline points="12 5 19 12 12 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
    </svg>
  `,
  edit: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke-width="2" stroke-linecap="round"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke-width="2" stroke-linecap="round"></path>
    </svg>
  `,
  server: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="2" y="2" width="20" height="8" rx="2" ry="2" stroke-width="2"></rect>
      <rect x="2" y="14" width="20" height="8" rx="2" ry="2" stroke-width="2"></rect>
      <line x1="6" y1="6" x2="6.01" y2="6" stroke-width="2"></line>
      <line x1="6" y1="18" x2="6.01" y2="18" stroke-width="2"></line>
    </svg>
  `,
  globe: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" stroke-width="2"></circle>
      <line x1="2" y1="12" x2="22" y2="12" stroke-width="2"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke-width="2"></path>
    </svg>
  `,
  heart: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
  `,
  code: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="16 18 22 12 16 6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
      <polyline points="8 6 2 12 8 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
    </svg>
  `,
  refreshCw: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <polyline points="23 4 23 10 17 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
      <polyline points="1 20 1 14 7 14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `,
  alertCircle: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" stroke-width="2"></circle>
      <line x1="12" y1="8" x2="12" y2="12" stroke-width="2"></line>
      <line x1="12" y1="16" x2="12.01" y2="16" stroke-width="2"></line>
    </svg>
  `,
  tv: (cls = 'w-5 h-5') => `
    <svg class="${cls}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="2" y="7" width="20" height="15" rx="2" ry="2" stroke-width="2"></rect>
      <polyline points="17 2 12 7 7 2" stroke-width="2"></polyline>
    </svg>
  `
};
